import React from 'react';
import '../Navbar/Bars.css';

const Footer = () => {
	return (
		<div className="footer">
			<p>
				Universidad Pedagógica Nacional Francisco Morazán, Colonia el Dorado, Frente a Plaza Miraflores
				<br />
				Fax. 2231-1257 Tel. 2239-8842/2235-8349/2239-8002/2235-6062
				<br />
				&copy;Copyright 2022. All Rights Reserved
			</p>
		</div>
	);
};
export default Footer;
